<template>
  <div class="job">
    <div class="columns job_item">
      <!--<div class="column is-narrow">-->
        <!--<div class="details">-->
          <!--&lt;!&ndash;<div class="detail">{{department}}</div>&ndash;&gt;-->
          <!--&lt;!&ndash;<div class="detail">{{role}}</div>&ndash;&gt;-->
          <!--&lt;!&ndash;<div class="c-tags">{{job.attributes.tags}}</div>&ndash;&gt;-->
          <!--&lt;!&ndash;<div class="loc">{{location}}</div>&ndash;&gt;-->
          <!--<div class="c-count">-->
            <!--<span class="icon">-->
              <!--<i class="fa fa-user-circle"></i>-->
            <!--</span>-->
            <!--{{candidatesCount}}-->
          <!--</div>-->
        <!--</div>-->
      <!--</div>-->
      <div class="column">
        <div class="job-title">{{job.attributes.title}}</div>
      </div>
    </div>

  </div>
</template>

<script>

  import httpUtil from '../../util/HttpResource';

  export default {
    name: 'job-item',

    created() {
      httpUtil.config = this.$config;
    },

    mounted() {
      this.jobLocationResource = this.$resource(httpUtil.requestUrl(`/api/org/${this.org_id}/jobs/${this.job.id}/location`));
      this.jobRoleResource = this.$resource(`${this.$config.API}/api/org/${this.org_id}/jobs/${this.job.id}/role`);
      this.jobDepartmentResource = this.$resource(`${this.$config.API}/api/org/${this.org_id}/jobs/${this.job.id}/department`);
      this.jobCandidatesCountResource = this.$resource(`${this.$config.API}/api/org/${this.org_id}/jobs/${this.job.id}/candidates_count`);
      this.getJobDetails();
    },

    data() {
      return {
        candidatesTags: 'Tags not set',
        department: 'Department: loading...',
        role: 'Role: loading...',
        candidatesCount: 'Loading candidates...',
        location: 'Location: loading...',
      };
    },

    methods: {
      /**
       * ------------------------------------
       */
      getJobDetails() {
        if (this.job.id) {
          // this.getJobLocations();
          // this.getJobRole();
          // this.getJobDepartment();
          // this.getCandidateCount();
        }
      },
      /**
       * ------------------------------------
       */
      async getCandidateCount() {
        const result = await this.jobCandidatesCountResource.get();
        if (!result.data.data) {
          this.candidatesCount = 'No candidates yet';
        } else {
          this.candidatesCount = `${result.data.data.count}`;
        }
      },
      /**
       * ------------------------------------
       */
      async getJobLocations() {
        const data = await this.jobLocationResource.get();
        if (!data.body.data) {
          this.location = 'Location not set';
        } else {
          this.location = data.body.data.attributes.city;
        }
      },
      /**
       * ------------------------------------
       */
      async getJobRole() {
        const data = await this.jobRoleResource.get();
        if (!data.body.data) {
          this.role = 'Role not set';
        } else {
          this.role = data.body.data.attributes.name;
        }
      },
      /**
       * ------------------------------------
       */
      async getJobDepartment() {
        const data = await this.jobDepartmentResource.get();
        if (!data.body.data) {
          this.department = 'Department not set';
        } else {
          this.department = data.body.data.attributes.name;
        }
      },
    },
    props: [
      'job',
      'org_id',
    ],
  };
</script>

<style scoped lang="scss">
  @import '../../styles/components/job_item';
</style>



// WEBPACK FOOTER //
// src/components/jobs/JobItem.vue